import React, { useRef, useState, useEffect } from 'react';
import { BaseButton, ImageCropModal, useT } from '@repo/common';

const UploadPhoto = ({ profile, setResumeData }) => {
  const t = useT();
  const defaultResumeProfile = `${process.env.REACT_APP_ASSETS_URL}/Career/img-resume-profile.svg`;

  const fileInputRef = useRef(null);

  const [selectedImage, setSelectedImage] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);
  const [showCropModal, setShowCropModal] = useState(false);

  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const imageURL = URL.createObjectURL(file);
    setSelectedImage(imageURL);
    setShowCropModal(true);

    e.target.value = '';
  };

  useEffect(() => {
    if (profile?.profileUrl) {
      setCroppedImage(profile.profileUrl);
    }
  }, [profile?.profileUrl]);

  return (
    <div className='w-full flex tabletH:flex-col items-center tabletH:items-start tabletH:pr-10 gap-2'>
      <div className='w-[60px] h-[75px] tabletH:w-[160px] tabletH:h-[200px] rounded-[8px] overflow-hidden'>
        <img
          src={croppedImage || defaultResumeProfile}
          alt='resume profile'
          className='w-full h-full object-cover'
        />
      </div>
      <BaseButton
        type='text'
        hideIcon
        bgclass='w-fit tabletH:w-full bg-transform border-none'
        hoverclass='hover:bg-transform border-none'
        onClick={handleUploadClick}
      >
        {croppedImage
          ? t('Change Photo', '사진 변경')
          : t('Upload photo', '사진 업로드')}
      </BaseButton>
      <input
        ref={fileInputRef}
        type='file'
        accept='.jpg,.jpeg,.png'
        className='hidden'
        onChange={handleFileChange}
      />

      {showCropModal && (
        <ImageCropModal
          image={selectedImage}
          onCancel={() => setShowCropModal(false)}
          onConfirm={(cropped) => {
            setCroppedImage(cropped);
            setResumeData((prev) => ({
              ...prev,
              profile: {
                ...prev.profile,
                profileUrl: cropped,
              },
            }));
            setShowCropModal(false);
          }}
          useIn='RESUME'
        />
      )}
    </div>
  );
};

export default UploadPhoto;
